import React from 'react';
import PatientFormTemplate from '../components/PatientFormTemplate';

/**
 * CNST patient self-report form entrypoint.
 *
 * The CNST form groups 5 conditions as separate questions, each with many subquestions.
 * We pass `formKey="cnst"` explicitly so the template binds to the correct stored form.
 */
export default function PatientCNSTForm() {
  return (
    <PatientFormTemplate
      formTitle="Combined Neurodevelopmental Screening Tool (CNST)"
      formKey="cnst"
    />
  );
}

